import { clsx } from 'clsx';
import { NumberInput, NumberInputProps } from './NumberInput';

export interface CurrencyInputProps extends Omit<NumberInputProps, 'onChange'> {
  currency?: 'USD';
  onChange?: (value: number | undefined) => void;
  value?: number | '';
}

export function CurrencyInput({
  currency = 'USD',
  error,
  onChange,
  value,
  ...props
}: CurrencyInputProps) {
  const adornmentCx =
    'flex items-center justify-center px-3.5 h-full bg-off-white-500';

  return (
    <NumberInput
      error={error}
      {...props}
      leftAdornment={
        <div className={clsx(adornmentCx, 'rounded-l border-r')}>$</div>
      }
      rightAdornment={
        <span className={clsx(adornmentCx, 'rounded-r border-l')}>
          {currency}
        </span>
      }
      thousandSeparator=","
      decimalScale={2}
      onValueChange={values => onChange?.(values.floatValue)}
      value={value ?? ''}
    />
  );
}
